import { defineStore } from "pinia";

// Agendamento em andamento (psi, data, horário, pagamento...) entre as telas do fluxo
export const useNewAppointmentStore = defineStore("newAppointment", {
  state: (): { data: any | null } => ({ data: null }),
  persist: true,
  actions: {
    save(params: any) {
      this.data = normalize(params);
    },
    update(params: any) {
      this.data = { ...(this.data || {}), ...normalize(params) };
    },
    clear() {
      this.data = null;
    },
  },
});

// "online" = sessão imediata, sem data definida
function normalize(params: any) {
  if (params?.date) {
    params.date = params.date === "online" ? null : params.date;
  }
  return params;
}
